import JSCookie from 'js-cookie';

const CookiePrefix = 'tmh_';

export const enum Cookie {
  Audience = 'audience',
}

export function getCookieValue(cookie: Cookie, defaultValue: any) {
  return JSCookie.get(`${CookiePrefix}${cookie}`) ?? defaultValue;
}

export function setCookieValue(cookie: Cookie, value: string, attributes: JSCookie.CookieAttributes = {}) {
  return JSCookie.set(`${CookiePrefix}${cookie}`, value, { ...attributes });
}
